import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["inputFormat"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext } from "react";
import { LocaleContext } from "@jutro/locale";
import { getInputFormat } from "../SimpleDateField/helpers";
import { SimpleDateField } from "../SimpleDateField/SimpleDateField";
export var SimpleMonthYearField = function (_ref) {
  var userInputFormat = _ref.inputFormat,
    props = _objectWithoutProperties(_ref, _excluded),
    dateLocale = useContext(LocaleContext).dateLocale;
  return React.createElement(SimpleDateField, _extends({}, props, {
    inputFormat: getInputFormat(["month", "year"], dateLocale, userInputFormat)
  }));
};
SimpleMonthYearField.displayName = "SimpleMonthYearField", SimpleMonthYearField.propTypes = _objectSpread({}, SimpleDateField.propTypes), SimpleMonthYearField.defaultProps = _objectSpread({}, SimpleDateField.defaultProps), SimpleMonthYearField.__docgenInfo = {
  description: "@metadataType field",
  methods: [],
  displayName: "SimpleMonthYearField",
  composes: ["../SimpleDateField/SimpleDateField"]
}, SimpleMonthYearField.__docgenInfo = {
  componentName: "SimpleMonthYearField",
  packageName: "@jutro/components",
  description: "",
  displayName: "SimpleMonthYearField",
  methods: [],
  actualName: "SimpleMonthYearField",
  metadataType: "field",
  composes: ["../SimpleDateField/SimpleDateField"]
};